import consentGatedInit from '@framework/cookie-consent/consentGatedInit';
import { ConsentCategory } from '@framework/cookie-consent/constants';
import { IConfiguration } from '@dealroadshow/jsbro/OTel/configuration';
import { SpanFilter } from '@framework/otel/CustomExporter';

interface ICreateOTelWebConfigParams {
  entry: string,
  instrumentations?: IConfiguration['instrumentations'],
  spanFilter?: SpanFilter,
}

/**
 * Defers OTel WebSDK initialization until functional consent cookie is present.
 */
export const createCookieConsentGatedOTelWebConfig = (params: ICreateOTelWebConfigParams): void => {
  consentGatedInit(ConsentCategory.Functional, () =>
    import('./createOTelWebConfig').then(({ createOTelWebConfig }) => {
      createOTelWebConfig(params);
    }),
  );
};
